import React from 'react';
import * as C from "../componentsM/index";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import pdf from "../assets/Fee_Structure.pdf";// Import useHistory hook from react-router-dom

// Your PDF component
const FeeStructure = () => {
  const pdfUrl = pdf; // Replace with the actual path to your PDF
  
  return (
    <>
      <C.Hero title={"FEE STRUCTURE"} image={"/hero/15.jpg"} />
      
      <section >
        <div >
          <Worker workerUrl={'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js'}>
            <div style={{ width: '100%', height: '150%' }}>
              <Viewer fileUrl={pdfUrl} />
            </div>
          </Worker>
        </div>
        <div className="mt-6 py-5 p-12">
        <a 
          href="/Scholarship" 
          className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
        >
          Scholarship Criteria
        </a>
      </div>
      </section>
    </>
  );
};

export default FeeStructure;
